var $ = require('jquery');


$(function() {
    addParentClass();
})

function addParentClass() {
    $('.block-type--heading').each(function() {
        if($(this).find('.is-style-heading--overlapping').length) {
            $(this).addClass('overlapping-parent');
        }
    })
    $('.block-type--paragraph').each(function() {
        if($(this).find('.is-style-text--eyebrow').length||$(this).find('.is-style-text--eyebrow-smaller').length) {
            $(this).addClass('eyebrow-parent');
        }
    })

    $('.wysiwyg-content').each(function () {
        $(this).find('.text--eyebrow').parent().addClass('wysiwyg-parent--eyebrow');
        $(this).find('.text--smaller').parent().addClass('wysiwyg-parent--smaller-text');
        $(this).find('.link--arrow').parent().addClass('wysiwyg-parent--link-arrow');
        $(this).find('.button').parent().addClass('wysiwyg-parent--button');
    })
}